var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.step > _vm.screens[0])?_c('v-btn',{attrs:{"text":"","small":"","rounded":""},on:{"click":function($event){return _vm.setBackStep()}}},[_vm._v("Anterior")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }